import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';

export const StyledTourCardContainer = styled.div(({
    theme,
    size,
    isSelected,
    hasBigBottomBorder,
}) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid ${token('colors.gray300')};
    margin-bottom: 2px;

    ${hasBigBottomBorder && css`
        border-bottom: 3px solid ${token('colors.blue400')};
        margin-bottom: 0px;
    `}

    ${size === 'md' && css`
        max-width: 320px;
        ${theme.ns().media.lg(css`
            width: 320px;
        `)}
    `}

    ${isSelected && css`
        box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
    `}
`);
